import React, { useState } from "react";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import { CommonCss } from "../../services/CommonCss";
import { HeaderCommonCss } from "./HeaderCss";
import { Box } from "@material-ui/core";
import clsx from "clsx";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';


export default function MenuSustainability(props) {
  const commonClasses = CommonCss();
  const headerClasses = HeaderCommonCss();
  
  const [open, setOpen] = React.useState(false);
  const [openUrl, setOpenUrl] = React.useState("");
  const handleClickOpen = (url) => {
    if(props.username){
      setOpenUrl(url);
      setOpen(true);
    } else {
      window.location = process.env.REACT_APP_PUBLIC_URL+url;
    }
  };
  
  const handleClose = (status) => {
    if(status){
      window.location = process.env.REACT_APP_PUBLIC_URL+openUrl;
    } 
    setOpen(false);
    setOpenUrl("");
  };
  return (
    <div>
       <Dialog
        open={open}
        onClose={()=>{handleClose(false)}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
         <div className="link-popup"> 
     <HighlightOffIcon onClick={()=>{handleClose(false)}} />
        <DialogTitle id="alert-dialog-title"></DialogTitle>
        <DialogContent>
        <Box
                component="img"
        
                display="block"
                margin="auto"
                className={" warning"}
                pb={1}  
               src={process.env.REACT_APP_CUSTOMER_PORTAL_URL +"assets/svg/Warning.svg"}
               />
        <DialogContentText id="alert-dialog-description">
          You are about to leave this page. You can come back by clicking the on Customer portal link under the
          Customer Icon  <Box
           pl={1}  
                component="img" 
               src={process.env.REACT_APP_CUSTOMER_PORTAL_URL +"assets/svg/customer-new.svg"} 
               />

          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
          Are you sure you want to continue to the website?
          </DialogContentText>
        </DialogContent>
        <DialogActions
          className="button-center custpop1"
          display="flex"
          justifyContent="center"
          alignItems="center"
          justifyContent="center"
        >
          <Button onClick={()=>{handleClose(false)}}  className="btn-style1">
          Cancel
          </Button>
          <Button onClick={()=>{handleClose(true)}}  className="btn-style2">
          Continue
          </Button>
        </DialogActions>
        </div>
      </Dialog>
      <Box
        position="fixed"
        component="section"
        className={clsx(headerClasses.innerMenuItemBox, "innerMenuItemBox")}
        width={1}
        left="0"
      >
        <Box className={commonClasses.navContainer} position="relative">
          <Box>
            <List>
              <ListItem>
                <Box
                  component="a"
                  //href={//process.env.REACT_APP_PUBLIC_URL + "un-sdg.html"}
                  onClick={()=>{handleClickOpen("un-sdg.html")}}
                >
                  Sustainable Development
                </Box>
              </ListItem>
              <ListItem>
                <Box
                  component="a"
                  //href={
                   // process.env.REACT_APP_PUBLIC_URL + "our-operations.html"
                  //}
                  onClick={()=>{handleClickOpen("our-operations.html")}}
                >
                  Our Operations
                </Box>
              </ListItem>
              <ListItem>
                <Box
                  component="a"
                  //href={process.env.REACT_APP_PUBLIC_URL + "our-customer.html"}
                  onClick={()=>{handleClickOpen("our-customer.html")}}
                >
                  Our Customers
                </Box>
              </ListItem>
              <ListItem>
                <Box
                  component="a"
                //  href={   process.env.REACT_APP_PUBLIC_URL +   "social-responsibility.html"  }
                onClick={()=>{handleClickOpen("social-responsibility.html")}}

                >
                  
                  Social Responsibility
                  </Box>
              </ListItem>
              <ListItem>
                <Box
                  component="a"
                 // href={
                  //  process.env.REACT_APP_PUBLIC_URL +   "Celebrating-40-Years-of-Clear-Thinking.html  }
                  onClick={()=>{handleClickOpen("Celebrating-40-Years-of-Clear-Thinking.html")}}
                >
                  
                  40 Years of Clear Thinking
                  </Box>
              </ListItem>
            </List>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
